import auth from "@/auth.js";

export default {
  [auth.roles.USER]: [
    {
      title: "GenDoc",
      action: "folder",
      subItems: [
        { text: "Блоки", routeName: "genDocBlocks" },
        { text: "Документація", routeName: "genDocDocuments" },
        { text: "Імпорт", routeName: "genDocImport" },
      ],
    },
  ],
  [auth.roles.ADMINISTRATOR]: [
    {
      title: "GenDoc",
      action: "folder",
      subItems: [
        { text: "Блоки", routeName: "genDocBlocks" },
        { text: "Документація", routeName: "genDocDocuments" },
        { text: "Імпорт", routeName: "genDocImport" },
      ],
    },
  ],
  [auth.roles.SALES_MANAGER]: [
    {
      title: "GenDoc",
      action: "folder",
      subItems: [
        { text: "Блоки", routeName: "genDocBlocks" },
        { text: "Документація", routeName: "genDocDocuments" },
        { text: "Імпорт", routeName: "genDocImport" },
      ],
    },
  ],
  [auth.roles.ACCOUNT_MANAGER]: [
    {
      title: "GenDoc",
      action: "folder",
      subItems: [
        { text: "Блоки", routeName: "genDocBlocks" },
        { text: "Документація", routeName: "genDocDocuments" },
        { text: "Імпорт", routeName: "genDocImport" },
      ],
    },
  ],
  [auth.roles.ACCOUNT_CLIENT]: [],
};
